import React, { useState, useRef, useEffect } from 'react';

const ToolCallCard = ({ toolName, status = 'running', logs = [] }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const outputBoxRef = useRef(null);

  useEffect(() => {
    if (outputBoxRef.current && !isCollapsed) {
      outputBoxRef.current.scrollTop = outputBoxRef.current.scrollHeight;
    }
  }, [logs, isCollapsed]);

  return (
    <div className={`tool-call-card ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="tool-card-head" onClick={() => setIsCollapsed(!isCollapsed)}>
        <div className="tool-head-left">
          <span className="tool-fn-name">
            <svg viewBox="0 0 24 24">
              <polyline points="16 18 22 12 16 6" />
              <polyline points="8 6 2 12 8 18" />
            </svg>
            <span>{toolName || 'execute_tool'}</span>
          </span>
        </div>

        <div className="tool-head-right">
          {status === 'running' ? (
            <div className="tool-status-pill running">
              <span className="tool-spinner"></span>
              <span>Выполняется...</span>
            </div>
          ) : (
            <div className="tool-status-pill success">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Завершено</span>
            </div>
          )}

          <svg className="tool-chevron-icon" viewBox="0 0 24 24">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>

      {!isCollapsed && (
        <div className="tool-output-box" ref={outputBoxRef}>
          {logs && logs.length > 0 ? (
            logs.map((log, idx) => {
              const text = typeof log === 'string' ? log : (log.text || '');
              const type = typeof log === 'object' && log.type ? log.type : (
                text.startsWith('[>]') || text.startsWith('$') || text.startsWith('node ') || text.startsWith('python') ? 'cmd' :
                text.startsWith('[+]') || text.startsWith('[✓]') || text.includes('OPEN') || text.toLowerCase().includes('успешно') ? 'success' :
                text.startsWith('[!]') || text.toLowerCase().includes('warn') || text.includes('FILTERED') ? 'warn' :
                'info'
              );

              return (
                <span key={idx} className={`tool-log-line ${type}`}>
                  {text}
                </span>
              );
            })
          ) : (
            <span className="tool-log-line info">[*] Инициализация вывода инструмента...</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolCallCard;
